import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { PortalCredentialGroupResultModel, PortalCredentialModel } from './credentials.models';
import { CredentialStatusLabelColor } from 'src/app/shared/models/credential/customPersonCredentialStatusDefinition.model';
import { CredentialsService } from './credentials.service';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-credentials',
  templateUrl: './credentials.component.html',
  styleUrls: ['./credentials.component.scss'],
  standalone: false
})
export class CredentialsComponent implements OnInit {
  credentialGroupResults: PortalCredentialGroupResultModel[] = [];
  CredentialStatusLabelColor = CredentialStatusLabelColor;
  groupLoaded = false;
  inProgressLoaded = false;
  renewalStarted = false;
  constructor(
    private credentialsService: CredentialsService,
    private appConfigService: AppConfigService,
    private router: Router,
    private oidcSecurityService: OidcSecurityService
  ) {}
  async ngOnInit(): Promise<void> {
    if (
      this.appConfigService.tenant.portalConfiguration &&
      this.appConfigService.tenant.portalConfiguration.showCredentialTab !== true
    ) {
      this.router.navigate(['portal/not-found'], {
        skipLocationChange: true
      });
    }
    this.credentialGroupResults = await this.credentialsService.getCredentialGroups();
    this.groupLoaded = true;
  }

  get loaded(): boolean {
    return this.groupLoaded && this.inProgressLoaded;
  }

  getColor(credential: PortalCredentialModel): string {
    return CredentialStatusLabelColor[credential.credentialStatus.color];
  }
  getLabel(credential: PortalCredentialModel): string {
    return credential.credentialStatus.label;
  }

  async startRenewal(personCredentialId: string): Promise<void> {
    if (this.renewalStarted) {
      return;
    }
    this.renewalStarted = true;
    const secureLinkId = await this.credentialsService.startRenewal(personCredentialId);
    this.renewalStarted = false;
    if (!secureLinkId) {
      return;
    }
    this.continueRenewal(secureLinkId);
  }

  continueRenewal(secureLinkId: string): void {
    this.oidcSecurityService.getUserData().subscribe((userData) => {
      const userId = userData?.sub;
      if (!userId) {
        return;
      }
      this.router.navigateByUrl(`portal/forms/${userId}/application/${secureLinkId}`);
    });
  }

  downloadPdf = (credential: PortalCredentialModel): void => {
    this.credentialsService.downloadCredentialPdf(credential.personCredentialId);
  };
}
